import { FC, useState } from "react";
import { TFunction } from "react-i18next";
import { ProductMapContentWrapper } from "../product-component/components/product-map-content/product-map-content.styled";
import { EServiceMapContent } from "./constants/service-map-content.constants";

type ServiceMapContentProps = {
  t: TFunction;
  onClick: (scrollTo: EServiceMapContent) => void;
};

type MapItem = {
  label: string;
  scrollTo: EServiceMapContent;
  isActive: boolean;
};

const ServiceMapContent: FC<ServiceMapContentProps> = ({ t, onClick }) => {
  const [contentItems, setContentItems] = useState<MapItem[]>([
    {
      label: t("productComponent.service.mapContent.detailLabel"),
      scrollTo: EServiceMapContent.DETAIL,
      isActive: true,
    },
    {
      label: t("productComponent.service.mapContent.informationLabel"),
      scrollTo: EServiceMapContent.INFORMATION,
      isActive: false,
    },
    {
      label: t("productComponent.service.mapContent.configLabel"),
      scrollTo: EServiceMapContent.SERVICE_CONFIG,
      isActive: false,
    },
  ]);

  const setIsActive = (index: number) => {
    setContentItems((items) =>
      items.map((content, i) => ({ ...content, isActive: i === index }))
    );
  };

  return (
    <ProductMapContentWrapper>
      <div className="content">
        {contentItems.map((item, i) => (
          <div
            key={`service-map-${item.scrollTo}`}
            className="item"
            onClick={() => {
              setIsActive(i);
              onClick(item.scrollTo);
            }}
          >
            <div className={`text ${item.isActive ? "isActive" : ""}`}>
              {item.label}
            </div>
          </div>
        ))}
      </div>
    </ProductMapContentWrapper>
  );
};

export default ServiceMapContent;
